import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "relative pt-4 px-4 flex-grow" }
const _hoisted_2 = {
  key: 0,
  class: "absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center gap-2"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, " Loading integration... ", -1)
const _hoisted_4 = {
  key: 1,
  class: "flex flex-col gap-3"
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"flex gap-2 items-center\"><div class=\"h-8\"><svg fill=\"none\" height=\"100%\" viewBox=\"0 0 411 400\" width=\"100%\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m260.297 203.125c4.109-.857 8.118-2.14 11.961-3.828v24.781c0 54.61-52.438 66.57-72.656 66.57-27.571 0-57.266-14.648-57.266-38.398 0-25.57 23-33.594 71.352-41 12.562-1.875 33.046-5.516 46.609-8.125zm150.156-3.125c0 110.453-91.883 200-205.226 200-113.3442 0-205.227-89.547-205.227-200 0-110.4531 91.8828-200 205.227-200 113.343 0 205.226 89.5469 205.226 200zm-94.195-24.398c0-8.133-.258-15.829-.258-22.571 0-42.875-20.563-64.3122-37.828-74.7497-17.638-9.7875-37.534-14.779-57.703-14.4766-42.789 0-74.313 12.0469-93.789 35.7422-11.231 14.0451-18.013 31.1231-19.477 49.0471-.043.462-.043.928 0 1.39.536 5.727 3.209 11.041 7.487 14.885 4.279 3.844 9.848 5.936 15.599 5.858 5.436.554 10.877-1.002 15.199-4.347 4.321-3.344 7.192-8.221 8.02-13.622 4.961-23.047 15.961-44.399 62.961-44.399 24.914 0 41.179 5.133 49.703 15.696 2.922 3.157 5.142 6.898 6.514 10.975 1.372 4.078 1.865 8.399 1.447 12.681 0 7.812-2.961 17.391-26.086 22.484-15 3.258-30.789 5.086-46.047 6.828l-7.305.868c-86.539 10.234-99.5856 55.89-99.5856 82.156 0 47.656 57.3126 74.617 98.7036 75.922h7.656c15.655.341 31.225-2.393 45.828-8.047l1.258-.524c14.308-5.45 27.271-13.926 38.003-24.847 10.731-10.922 18.978-24.032 24.176-38.434 6.743-18.164 6.133-55.523 5.524-88.515z\" fill=\"#007bc7\"></path></svg></div><h1 class=\"text-3xl font-bold\">Appfolio</h1></div><p>Integrate Thatch into Appfolio</p>", 2)
const _hoisted_7 = { class: "flex flex-col gap-2" }
const _hoisted_8 = { class: "flex items-center gap-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-bold" }, " Send documents to Appfolio ", -1)
const _hoisted_10 = {
  key: 0,
  class: "bg-green-500 text-xs text-white rounded-md py-0.5 px-4"
}
const _hoisted_11 = {
  key: 1,
  class: "bg-red-400 text-white rounded-md py-0.5 text-xs px-4"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between gap-6" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Send invoices your receive via physical mail, faxes, or email attachments to Appfolio, easily. ")
], -1)
const _hoisted_13 = { class: "flex flex-col gap-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-bold" }, " Connect your appfolio account ")
], -1)
const _hoisted_15 = { class: "max-w-screen-sm w-full" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col gap-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-2" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-bold" }, " How to get your Appfolio email ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Type "),
    /*#__PURE__*/_createElementVNode("b", null, "Smart Bill Entry"),
    /*#__PURE__*/_createTextVNode(" in the search bar, or navigate to the task by clicking Accounting > Payables > Smart Bill Entry. Copy the email listed in the Upload Invoices block and provide it to your vendors. ")
  ]),
  /*#__PURE__*/_createElementVNode("img", {
    class: "mt-4 w-9/12",
    src: "/appfolio-screenshot.jpg"
  })
], -1)

import {
	UiLoader,
	UiCard,
	UiButton,
	UiInput,
	useForm,
	UiForm
} from '@/ui-kit';
import { useToggle } from '@vueuse/core';
import { useIntegrations } from '../use-intergations';
import { onBeforeMount } from 'vue';
import { env } from '@/config';
import { useRoute, useRouter } from 'vue-router';
import { required, email } from '@vuelidate/validators';


export default /*#__PURE__*/_defineComponent({
  __name: 'Appfolio',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const {
	appfolioIntegration,
	isAppfolioLoaded,
	attachAppfolio,
	deleteAppfolio,
	loadAppfolio
} = useIntegrations();
const [isConnecting, setIsConnecting] = useToggle();

onBeforeMount(async () => {
	if (!isAppfolioLoaded.value) {
		await loadAppfolio();

		if (appfolioIntegration.value) {
			fillFormData(appfolioIntegration.value);
		}
	}
});

const { formData, onSubmit, fillFormData } = useForm(
	{
		email: ''
	},
	{
		email: {
			required,
			email
		}
	}
);

const attach = onSubmit(async (data) => {
	setIsConnecting(true);
	await attachAppfolio(data.email);
	setIsConnecting(false);
});

async function disconnect() {
	setIsConnecting(true);
	await deleteAppfolio();
	setIsConnecting(false);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(isAppfolioLoaded))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_unref(UiLoader))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_unref(UiCard), { theme: "white" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  (_unref(appfolioIntegration))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Enabled "))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11, " Disabled "))
                ]),
                _hoisted_12
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(UiCard), { theme: "white" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_unref(UiForm), {
                  class: "flex justify-between gap-2 w-full",
                  onSubmit: _unref(attach)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_unref(UiInput), {
                        name: "email",
                        label: "Add your appfolio email address here",
                        type: "email",
                        placeholder: "yourappfoliobleemail@appfolio-mail.com",
                        modelValue: _unref(formData).email,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).email) = $event)),
                        disabled: 
									_unref(isConnecting) ||
									!!_unref(appfolioIntegration)
								
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    (!_unref(appfolioIntegration))
                      ? (_openBlock(), _createBlock(_unref(UiButton), {
                          key: 0,
                          class: "!h-8 mt-9 ml-auto",
                          theme: "primary-outlined",
                          loading: _unref(isConnecting)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Connect ")
                          ]),
                          _: 1
                        }, 8, ["loading"]))
                      : (_openBlock(), _createBlock(_unref(UiButton), {
                          key: 1,
                          onClick: disconnect,
                          class: "!h-8 mt-9 ml-auto",
                          theme: "danger-outlined",
                          loading: _unref(isConnecting)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Disconnect ")
                          ]),
                          _: 1
                        }, 8, ["loading"]))
                  ]),
                  _: 1
                }, 8, ["onSubmit"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(UiCard), { theme: "white" }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          })
        ]))
  ]))
}
}

})